import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface AlertModel {
    title: string;
    message: string;
}

@Component({
    selector: 'ep-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    standalone: false
})
export class AlertDialogComponent implements OnInit {
    @Input() title: string;
    @Input() message: string;
    @Input() btnOkText: string;

    constructor(private activeModal: NgbActiveModal) { }

    ngOnInit() { }

    public accept() {
        this.activeModal.close(true);
    }

    public dismiss() {
        this.activeModal.dismiss();
    }
}
